import React from "react"
import styled from "styled-components"
import Seo from "./seo"
import { CheckoutContext } from "../../../contexts/checkout-context"

function nameToMetadataCategory(name, catobj) {
  const categoryIndex = catobj.findIndex(cat => cat.Slug === name)
  const metadataTitle = catobj[categoryIndex]?.MetadataTitle
  const metadataDescr = catobj[categoryIndex]?.MetadataDescription
  return [metadataTitle, metadataDescr]
}
function nameToMetadataSubcategory(name, catobj) {
  const categoryIndex = catobj.findIndex(cat => cat.Slug === name)
  const metadataTitle = catobj[categoryIndex]?.MetadataTitle
  const metadataDescr = catobj[categoryIndex]?.MetadataDescription
  return [metadataTitle, metadataDescr]
}

export default function SeoPicker({ prerenderdata, cmsCategoryData }) {
  const currentURLCategory = prerenderdata.category
  const currentURLSubCategory = prerenderdata.subategories
  return (
    <>
      <CheckoutContext.Consumer>
        {({ activeCategory, activeSubCategory }) => {
          // console.log("activeCategory: ")
          // console.log(activeCategory)
          // console.log("activeSubCategory: ")
          // console.log(activeSubCategory)
          if (
            activeCategory &&
            activeCategory != "all" &&
            (!activeSubCategory || activeSubCategory == "all")
          ) {
            const [title, descr] = nameToMetadataCategory(
              activeCategory,
              cmsCategoryData.Categories
            )
            return (
              <>
                <Seo title={title} description={descr} />
              </>
            )
          }
          if (
            activeCategory &&
            activeSubCategory &&
            activeSubCategory != "all"
          ) {
            const categoryIndex = cmsCategoryData.Categories.findIndex(
              cat => cat.Slug === activeCategory
            )
            // const [catTitle, catDescr] = nameToMetadataCategory(activeCategory, cmsCategoryData.Categories);
            const [title, descr] = nameToMetadataSubcategory(
              activeSubCategory,
              cmsCategoryData.Categories[categoryIndex].SubCategories
            )
            return (
              <>
                <Seo title={title || ""} description={descr} />
              </>
            )
          }
          return <></>
        }}
      </CheckoutContext.Consumer>
    </>
  )
}
